import { render, staticRenderFns } from "./TRoom.vue?vue&type=template&id=250be0d3&"
import script from "./TRoom.vue?vue&type=script&lang=js&"
export * from "./TRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports